import React from 'react';
import { Typography, Link, Button } from '@one-thd/sui-atomic-components';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ADDITIONAL_APPROVERS_DESCRIPTION } from '../../../constants/remote-purchases';
import { AUTHORIZE_CARDS_T2C_PAGE_URL } from '../../../constants/links';
import { InputFieldsRow } from './multiple-inputs-row';
import { b2bPaymentsApi } from '../../../api/b2b/payments';
import { removeNonDigitsFromString } from '../../../utils/general';
import { AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK } from '../../../constants/analytics';
import { track } from '../../../utils/analytics';
export const MultipleApproversSection = () => {
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        name: 'additionalApprovers',
        control,
        rules: { maxLength: 5 },
    });
    const onAddApprover = () => {
        track(AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK, {
            section: 'authorize remote purchases overlay',
            actionType: 'add additional approvers',
        });
        append({ fullName: '', t2cNumber: '', status: null });
    };
    const onClickMoreInfo = () => {
        track(AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK, {
            section: 'text2confirm',
            actionType: 'more info link',
        });
    };
    const addApproverButton = (React.createElement(Button, { variant: "secondary", fullWidth: true, onClick: onAddApprover }, "+ Add Additional Approvers"));
    const showAddApproverButton = fields.length > 0 && fields.length < 5;
    const resendInvite = (number) => {
        if (!number)
            return Promise.resolve(false);
        return b2bPaymentsApi
            .multiResendT2CRequest({
            t2cResendInviteRequest: {
                resendAllPending: false,
                resendInvites: [removeNonDigitsFromString(number)],
            },
        })
            .then(({ data }) => {
            return data.success;
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, null, ADDITIONAL_APPROVERS_DESCRIPTION),
        React.createElement("div", { className: "sui-mt-4" },
            React.createElement(Link, { href: AUTHORIZE_CARDS_T2C_PAGE_URL, target: "_blank", onClick: onClickMoreInfo }, "More Info")),
        React.createElement("div", { className: "sui-mb-4" }, fields.map((field, index) => (React.createElement("div", { key: field.id },
            React.createElement(InputFieldsRow, { control: control, index: index, onRemove: () => {
                    remove(index);
                }, onResend: () => {
                    return resendInvite(field.t2cNumber);
                } }))))),
        showAddApproverButton && addApproverButton));
};
